export default __webpack_public_path__ + "static/media/shubhangi-khare-post.f22cf58d.png";